import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { Parte } from '../../../models/parte';
import { ParteAnagraficaUpdateComponent } from './parte-anagrafica-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [parte-mod-anagrafica-update]',
  templateUrl: 'parte-mod-anagrafica-update.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ParteModAnagraficaUdate {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<Parte> = new EventEmitter<Parte>();
  @ViewChild('formAnagraficaParte') modaleAnagrafica: ParteAnagraficaUpdateComponent;

  inizializza(urlUpdateAnagrafica: string, parte: Parte, tipoPratica, idTipoFascicolo = null, isControparti: boolean = false) {
    this.modaleAnagrafica.inizializza(urlUpdateAnagrafica, parte, tipoPratica,idTipoFascicolo, isControparti);
    openModal('modalmodanagrafica');
  }

  createForm() {
    this.modaleAnagrafica.createForm();
  }

  manageModal(event) {
      closeModal('modalmodanagrafica');
      this.onReturn.emit(event);
  }
}
